export const getSessionStorageItem = (key: string) => {
  return sessionStorage.getItem(`${key}`);
};

export const setSessionStorageItem = (key: string, value: any) => {
  return sessionStorage.setItem(`${key}`, value);
};

export const removeSessionStorageItem = (key: string) => {
  return sessionStorage.removeItem(`${key}`);
};

 /**
   * @param {string} key - A key to identify the value.
   * @param {any} value - A value associated with the key.
   * @param {number} ttl- Time to live in seconds.
   */
export const setSessionStorageItemTtl = (key: string, value: any, ttl?: number | null) => {
  const data = {
      value: value,                  // store the value within this object
      ttl: Date.now() + ((ttl ?? 9999999) * 1000),   // store the TTL (time to live)
  };

  // store data in sessionStorage 
  return sessionStorage.setItem(`${key}`, JSON.stringify(data));
};

/**
* @param {string} key - A key to identify the data.
* @param {any|null} callback - callback function if expire value.
* @returns {any|null} returns the value associated with the key if its exists and is not expired. Returns `null` otherwise
*/
export const getSessionStorageItemTtl = (key: string, callback?: any) => {
  const jsonData: any = sessionStorage.getItem(`${key}`);
  if (!jsonData) {     // if no value exists associated with the key, return null
      return null;
  }

  const data = JSON.parse(jsonData);

  // If TTL has expired, remove the data from sessionStorage and return null
  if (!data.ttl || Date.now() > data.ttl) {
    sessionStorage.removeItem(`${key}`);
    if (callback) callback(data.value);
    return null;
  }

  // return data if not expired
  return data.value;
}
